import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Helmet} from "react-helmet";
import {Animated} from "react-animated-css";
import {fetchPortfolios} from '../actions/index';

class Portfolio extends Component{
  componentDidMount(){
    if(this.props.portfolios.length === 0){
      this.props.fetchPortfolios();
    }
  }
  render(){
    const portfolioId = parseInt(this.props.match.params.portfolioId, 10);
    const portfolioFilter = this.props.portfolios.filter((item) => (item.portfolio_id == portfolioId));
    if(portfolioFilter.length === 0){
      return (
        <div>
          ไม่พบหน้าที่ท่านค้นหาอยู่
        </div>
      )
    }
    const portfolio = portfolioFilter[0];
    return (
      <Animated animationIn="fadeInUp" className="container pt-4">
        <Helmet>
          <title>{portfolio.name} - GongIdeas | Let's imagine come true.</title>
        </Helmet>
        <div className="mx-auto" style={{maxWidth:600}}>
          <h1 className="text-center mb-2">{portfolio.name}</h1>
          <div className="text-center mb-4">{portfolio.type}</div>
          <div dangerouslySetInnerHTML={{ __html: portfolio.detail }} />
        </div>
      </Animated>
    );
  }
}
export default connect((state) => state, {fetchPortfolios})(Portfolio);


// WEBPACK FOOTER //
// ./src/components/Portfolio.js